import { Worker, Viewer } from "@react-pdf-viewer/core";
import { isMobileApp } from "../../../utils/util";


const DocModal = ({ url, show, onClose, translationMap, base64, assessmentName }) => {


  if (!show) return null;

  return (
    <div
      className="modal fade Custom_Modal_Box show"
      id="documentpdfmodal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="exampleModalCenterTitle"
      aria-hidden="true"
      style={{
        display: "block"
      }}>
      
            <div className="modal-dialog  CoveragePlan_Dialog1" role="document">

                <div className="modal-content">
                    <div className="modal-header">
                        <div className="Title_Inner_Box">
                            <span className="material-symbols-outlined">
                                radio_button_unchecked
                            </span>
                            <h6 className="MainTitleOne">
                                {assessmentName} {translationMap?.assessmentReportText ?? "Assessment Report"}
                            </h6>
                        </div>
                    </div>
                    <div className="modal-body baraem-pdf-height" style={{ direction: 'ltr' }}>

                        <Worker style={{ height: 'auto' }}
            workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
                            <Viewer fileUrl={
              url ? url :
              "Loading..."
              } />
              
                        </Worker>
                        
                    </div>
                    <div className="modal-footer modal_footer_btn_box">
                        <button type="button" className="btn bluetrans_btn_link" data-dismiss="modal" onClick={onClose}>
                            {translationMap?.goBack}
                        </button>

                        {isMobileApp() ? null : <a
              href={base64 ? `data:application/pdf;base64,${base64}` : "#"}
              className="blue_btn_link"
              download={"baraem-report.pdf"}>
              
                            {translationMap?.download}
                        </a>
            }
                    </div>
                    
                </div>
            </div>
        </div>);

};

export default DocModal;